import config from '@nn-design-system/config/web';
import { getFontFamily as getAliasFontFamily, getFontSize as getAliasFontSize, getFontStyle as getAliasFontStyle, getLineHeight as getAliasLineHeight, getFontWeight as getAliasFontWeight, getVerticalAlign as getAliasVerticalAlign, getTextAlign as getAliasTextAlign, getTextDecoration as getAliasTextDecoration, getTextDecorationThickness as getAliasTextDecorationThickness, getTextUnderlineOffset as getAliasTextUnderlineOffset, } from './typography.alias';
import Transformer from '../transformations/web';
export function getFontFamily() {
    return getAliasFontFamily(new Transformer(), config);
}
export function getFontSize() {
    return getAliasFontSize(new Transformer());
}
export function getFontStyle() {
    return getAliasFontStyle(new Transformer(), config);
}
export function getLineHeight() {
    return getAliasLineHeight(new Transformer());
}
export function getFontWeight() {
    return getAliasFontWeight(new Transformer());
}
export function getVerticalAlign() {
    return getAliasVerticalAlign(new Transformer());
}
export function getTextAlign() {
    return getAliasTextAlign(new Transformer());
}
export function getTextDecoration() {
    return getAliasTextDecoration(new Transformer());
}
export function getTextDecorationThickness() {
    return getAliasTextDecorationThickness(new Transformer());
}
export function getTextUnderlineOffset() {
    return getAliasTextUnderlineOffset(new Transformer());
}
